/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CleanableNumber } from './cleanableNumber';

export interface Long2ObjectHashMapCleanableNumber {
  [key: string]: CleanableNumber | any;

  empty?: boolean;
}
